/**
 * Mũi tên xuống (thân + chữ V) — cùng mark với tiêu đề « Featured Work ».
 * Dùng `className` cho kích thước và màu (vd. text-brand).
 */
export default function SectionArrowDown({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 ${className}`.trim()}
      aria-hidden
    >
      <path d="M12 5v14M5 12l7 7 7-7" />
    </svg>
  );
}

/** Cùng nét với SectionArrowDown, hướng ngang sang phải — dùng trong PillButton / CTA. */
export function SectionArrowRight({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 ${className}`.trim()}
      aria-hidden
    >
      <path d="M4 12h14M11 5l7 7-7 7" />
    </svg>
  );
}
